import React, { memo } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
const POINTS = ['No image, URL, or post content is ever transmitted anywhere.', 'No analytics, telemetry, advertising, tracking, or fingerprinting.', 'No cookies, no remote storage, no developer server.', 'Captured images live in memory only while the result dialog is open.'];
const PERMS = [{
  name: 'activeTab',
  why: 'Capture the visible X tab — only after you click the icon.'
}, {
  name: 'scripting',
  why: 'Scroll the post into view while stitching long captures.'
}, {
  name: 'downloads',
  why: 'Save the PNG via the standard save dialog.'
}, {
  name: 'clipboardWrite',
  why: 'Copy the PNG to your system clipboard.'
}];
export function PrivacySection() {
  return <section id="privacy" className="w-full scroll-mt-16 bg-white py-20 sm:py-24" data-id="element-173" data-mp="3tr8n6tvvtcy5">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-174" data-mp="3os5hd782v2p4">
        <div className="grid gap-10 lg:grid-cols-2 lg:items-start" data-id="element-175" data-mp="3otox8wptnbqd">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4
        }} data-id="element-176" data-mp="7kaaxo1aztc1">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#1d9bf0]/10 px-3 py-1 text-xs font-semibold text-[#1d9bf0]" data-id="element-177" data-mp="qa8j0453pmfo">
              <VerifiedUserOutlinedIcon sx={{
              fontSize: 16
            }} data-id="element-178" data-mp="lcq7c5zp8t3z" />
              Privacy by design
            </span>
            <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-slate-900 sm:text-4xl" data-id="element-179" data-mp="vae2uy54q4n7">
              Your posts never leave your device
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600" data-id="element-180" data-mp="12ayf9rp1qdfg">
              X2PIC collects nothing. There’s no account to create and no server
              to trust — the extension simply renders the screenshot you asked
              for, on your machine.
            </p>
            <ul className="mt-6 space-y-3" data-id="element-181" data-mp="1h3s6299rqfzf">
              {POINTS.map(p => <li key={p} className="flex items-start gap-3 text-slate-700" data-id="element-182" data-mp="1l2r73isdpsll">
                  <CheckCircleOutlineIcon sx={{
                fontSize: 20
              }} className="mt-0.5 shrink-0 text-[#1d9bf0]" data-id="element-183" data-mp="1q1cbzvikt0gd" />
                  <span className="text-sm leading-relaxed" data-id="element-184" data-mp="1zz8lkivv7ncd">{p}</span>
                </li>)}
            </ul>
            <Link to="/privacy" className="mt-7 inline-flex items-center gap-1 text-sm font-semibold text-[#1d9bf0] hover:underline" data-id="element-185" data-mp="pii3g9fut94">
              Read the full privacy policy →
            </Link>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: 0.1
        }} className="rounded-2xl border border-slate-200 bg-slate-50 p-6 sm:p-8" data-id="element-186" data-mp="2e50q9fke9lnb">
            <h3 className="text-base font-semibold text-slate-900" data-id="element-187" data-mp="2sugcci8zd2wo">
              Minimal permissions, clearly explained
            </h3>
            <p className="mt-1 text-sm text-slate-500" data-id="element-188" data-mp="2nvd64uh9kqn4">
              No{' '}
              <code className="rounded bg-white px-1 py-0.5 text-xs" data-id="element-189" data-mp="1hgud249epkxf">
                &lt;all_urls&gt;
              </code>
              . Nothing beyond x.com / twitter.com.
            </p>
            <div className="mt-5 divide-y divide-slate-200 overflow-hidden rounded-xl border border-slate-200 bg-white" data-id="element-190" data-mp="30d5z79k6g8v1">
              {PERMS.map(p => <div key={p.name} className="flex flex-col gap-1 p-4 sm:flex-row sm:items-center sm:gap-4" data-id="element-191" data-mp="355z3jwbqhf6l">
                  <code className="w-fit rounded-md bg-[#1d9bf0]/10 px-2 py-0.5 text-xs font-semibold text-[#1d9bf0]" data-id="element-192" data-mp="2wcc867bfudxx">
                    {p.name}
                  </code>
                  <span className="text-sm text-slate-600" data-id="element-193" data-mp="3o3a0vbdt1yje">{p.why}</span>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}